module.exports = __webpack_public_path__ + "static/img/es1s1_icons.03db540.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/es1s1_icons.svg
// module id = ySVO
// module chunks = 1